import { FC } from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';
import { SquareEditOutlineSvg } from './svgs';

export const IconSquareEditOutline: FC<SvgIconProps> = (props) => {
  return <SvgIcon component={SquareEditOutlineSvg} viewBox="0 0 24 24" {...props} />;
};
